export default __webpack_public_path__ + "static/media/lineCapArrow.df323030.svg";